<template>
    <div class="floors">
        <div class="lc-pro-t">
            留学申请流程<span>不同国家办理流程稍有不同，详细可选择在线咨询各国顾问老师</span>
        </div>
        <ul class="lc-list">
            <li 
                :class="current == index ? 'lc-item active types'+(index) : 'lc-item types'+(index)" 
                v-for="(item, index) in staticData"
                :key="index"
                @mouseenter="maskShow(index)"
                @mouseleave="maskHide(index)">
                <span class="names">{{item.name}}</span>
                <span class="index">{{index + 1}}</span>
                <div class="child">
                    <a 
                        v-for="(child, cindex) in item.child"
                        rel="nofollow"
                        target="_blank"
                        :key="cindex"
                        :href="child.link">
                        ·&nbsp;&nbsp;{{child.name}}
                    </a>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import { shenqing } from 'js/gobroad/shenqingliucheng'
export default {
    data () {
        return {
            staticData: shenqing,
            current: 0
        }
    },
    methods: {
        maskShow (index) {
            this.current = index
        },
        maskHide (index) {
            // this.current = -1
        }
    }
}
</script>

<style scoped lang="stylus">
.floors
    width: 1200px
    margin: 0 auto
    padding-top: 37px
    margin-bottom: 140px
    .lc-list
        font-size: 0
        text-align: center
        padding: 0 20px
        .lc-item
            display: inline-block
            vertical-align: middle
            width: 118px
            height: 75px
            position: relative
            cursor: pointer
            margin-right: 18px
            background: url(http://www.xdf.cn/zhuanti/liuxuenew/img/icon@jiantou.png) right center no-repeat;
            .names
                color: white
                font-size: 15px
                box-sizing: border-box
                position: absolute
                line-height: 18px
                top: 0
                left: 0
                width: 75px
                height: 75px
                padding: 18px 20px 0 17px
                background #51d2ba
                border-radius 50%
            .index
                color: white
                font-size: 14px
                position: absolute
                top: 22px
                left: 58px
                background #51d2ba
                border-radius 50%
                width 23px
                height 23px
                text-align center
                line-height 23px
                border 3px solid #fff
            .child
                position: absolute
                padding: 0 15px
                height: 35px
                word-break: keep-all
                left: 31%
                transform: translate(-50%,0)
                bottom: -52px
                text-align left 
                white-space: nowrap
                border: 1px solid #51d2ba
                display: none
                min-width: 140px
                a
                    line-height: 35px
                    font-size: 12px
                    display: inline-block
                    padding-right 12px
                    white-space: nowrap
            
            .child:after
                content: ""
                position: absolute
                width: 5px
                height: 5px
                border-left: 1px solid #51d2ba
                border-top: 1px solid #51d2ba
                top: -4px
                left: 50%
                margin-left: -3px
                background-color: #fff
                transform: rotateZ(45deg)
            &:last-child
                width 87px
                margin-right 0
                .child
                    left 44%
        
        :last-child
            background none            
        :nth-child(2),:nth-child(6),.types1
            .names
                background #ffc063
            .index
                background #ffc063
            .child
                border-color #ffc063
                &:after
                    border-color #ffc063
        :nth-child(2).active,:nth-child(6).active,.types1.active
            .names
                 border-color #fbefdc
                // box-shadow 0 0 4px 5px rgba(255,192,99,0.4)
        :nth-child(4),:nth-child(7)
            .names
                background #f38d8d
            .index
                background #f38d8d
            .child
                border-color #f38d8d
                &:after
                    border-color #f38d8d
        :nth-child(4).active,:nth-child(7).active
            .names
                border-color #fcdede
                // box-shadow 0 0 4px 5px rgba(243,141,141,0.4)
        .active
            .names
                width 85px
                height 85px
                left -5px
                top -5px
                border 5px solid #d7f5ef
                // box-shadow 0 0 4px 5px rgba(81,210,186,0.4)
            .child
                display: block
                a:hover
                    color: #00b388
            
    
    
    
    .lc-pro-t
        height: 40px
        line-height: 40px
        border-bottom: 2px solid #98dfd2
        padding: 0 6px
        font-size: 20px
        color: #333
        margin-bottom: 68px
        span
            float: right
            font-size: 12px
            line-height 42px
            color: #eea017
            padding-left: 20px
            background: url(http://images.xdf.cn/cms20150819/liuxue/public/img/icon_info.png) center left no-repeat
        :after
            display: block
            content: ''
            clear: both

</style>


// WEBPACK FOOTER //
// src/pages/gobroad/components/mainfloor/TimeLine.vue